function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}"));

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 0.2616,
  y: -0.01117,
  width: 24,
  height: 24
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M19.99854,11.13626a7.56375,7.56375,0,0,0-7.16846-7.13672h-.42871a7.57991,7.57991,0,0,0-6.856,10.78808L4.02832,19.34524a.50037.50037,0,0,0,.47461.6582.51788.51788,0,0,0,.1582-.02539l4.55616-1.52148a7.52584,7.52584,0,0,0,3.1831.71h.01953A7.59076,7.59076,0,0,0,20,11.57961ZM18.30371,14.524A6.548,6.548,0,0,1,12.418,18.16653h-.01709A6.51038,6.51038,0,0,1,9.478,17.47122a.50871.50871,0,0,0-.38379-.02832L5.29346,18.71243l1.26562-3.80176a.50152.50152,0,0,0-.02832-.38379,6.58672,6.58672,0,0,1,5.87158-9.52734h.01123l.38916-.001a6.55441,6.55441,0,0,1,6.19678,6.166l.00049.417A6.52128,6.52128,0,0,1,18.30371,14.524Zm-8.21094-2.793a.88965.88965,0,1,1-.89209-.88965h.00244A.89075.89075,0,0,1,10.09277,11.731Zm3.42237-.001a.8899.8899,0,1,1-.89014-.88965A.89075.89075,0,0,1,13.51514,11.73Zm3.293-.001a.88965.88965,0,0,1-1.7793,0,.89022.89022,0,0,1,.88965-.88965A.89075.89075,0,0,1,16.80811,11.729Z"
});

function SvgKeywordGroups(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeywordGroups);
export default __webpack_public_path__ + "static/media/keyword-groups.ec6568c8.svg";
export { ForwardRef as ReactComponent };